import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { initialState, SLICE_NAMESPACE } from './constants';
import { reducers } from './reducers';

const { actions, reducer } = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers,
  extraReducers,
});

export const {
  updateYapePromoPage,
  updateYapeQrPage,
  changeSearchMethod,
  updateYapePromoFilters,
  updateYapeQrFilters,
  clearYapePromoFilters,
  clearYapeQrFilters,
  clearYapeForm,
} = actions;

export default reducer;
